import { create } from 'zustand';
export const useSearchStore = create((set) => ({
    searchInput: '',
    searchQuery: '',
    onlyActive: true,
    cache: null,
    cacheKey: '',
    setSearchInput: (value) => set({ searchInput: value }),
    setSearchQuery: (value) => set({ searchQuery: value }),
    setSearchOnlyActive: (value) => set({ onlyActive: value }),
    setCache: (value) => set({ cache: value }),
    setCacheKey: (value) => set({ cacheKey: value }),
    clear: () => set({
        searchInput: '',
        searchQuery: '',
        cache: null,
        cacheKey: '',
    }),
}));
